import { BASE_URL } from '@/config'
export async function login(email, password) {
  try {
    const response = await fetch(`${BASE_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao fazer login')
    }

    const data = await response.json()

    if (data.token) {
      localStorage.setItem('token', data.token)
    }

    return data
  } catch (error) {
    console.error('Erro no login:', error)
    throw error
  }
}

export async function register(
  email,
  name,
  password,
  EmpresaID,
  Empresa,
  role
) {
  try {
    const response = await fetch(`${BASE_URL}/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        name,
        password,
        EmpresaID,
        Empresa,
        role,
      }),
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao registrar usuário')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao registrar usuário:', error)
    throw error
  }
}

export async function AdminLogin(email, password) {
  try {
    const response = await fetch(`${BASE_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao fazer login')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro no login:', error)
    throw error
  }
}

export async function getUserByEnterpriseId(enterpriseId) {
  try {
    const response = await fetch(
      `${BASE_URL}/auth/enterprise/${enterpriseId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    )
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao buscar usuários')
    }
    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar usuários:', error)
    throw error
  }
}
